import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { PqrTypeDataProps } from './props';
import { useEffect, useState } from 'react';
import { ParamEnum } from '../../../../../../shared/types/shared';
import { Param } from '../../../../../../shared/types/param';
import { asyncGetLastCodeSuffixParam } from '../../../../../../services/param.service';

export const usePqrTypeData = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrTypeDataProps) => {
    const [newCode, setNewCode] = useState<string>('');
    const onSubmit = (data: Param) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('code', data?.code || newCode);
        formik?.setFieldValue('class', data?.class || ParamEnum.PQR_TYPE);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active ?? true);
        formik?.setFieldValue('extra', data?.extra || '');
    }, [data, newCode]);

    useEffect(() => {
        asyncGetLastCodeSuffixParam(ParamEnum.PQR_TYPE).then((res: any) => {
            setNewCode(res?.items);
        });
    }, [newCode]);

    return {
        formik,
    };
};
